import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../Firebase";
import { doc, getDoc } from "firebase/firestore";
import HeroBanner from "../components/HeroBanner";
import Departments from "../components/Departments";
import Doctors from "../components/Doctors";
import AppointmentForm from "../components/AppointmentForm";
import Contact from "../components/Contact";
import Carousel from "../components/Carousel";
import CountUp from "react-countup";
import {
  FiHeart,
  FiUser,
  FiActivity,
  FiSmile,
  FiStar,
  FiCheckCircle,
  FiChevronDown,
  FiChevronUp,
  FiPhoneCall,
  FiAward,
  FiShield,
  FiCpu,
  FiX,
} from "react-icons/fi";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const generalTestimonials = [
  {
    title: "Ashil Kamble",
    description:
      "I was severe paining in stomch and ommiting also. My brother in low brought here in swarup hospital Dr deshapande advice me sonography immedietly and admitted on 18 sep. I got a treatment very nice and staff also very good treatment given me. I thanks to all concerned and doctor.",
    id: 1,
    meta: "Stomach Pain Patient",
    icon: <FiHeart className="carousel-icon" />,
  },
  {
    title: "Dhairyasheel Pawar",
    description:
      "Had admitted my mother for a surgery, Dr. Radhika Deshpande ma'am handled the matter very well and the surgery went good , Even Dr. Mandar sir and Dr. Suresh Sir was very reassuring and kept the vibe friendly and safe. Whole of the Hospital staff is prompt and friendly . ",
    id: 4,
    meta: "Surgery Care",
    icon: <FiActivity className="carousel-icon" />,
  },
  {
    title: "Mayura Kesarkar",
    description:
      "Nice experience in the swarup hospital.here I m admitted for my 3 surgeries that are gall stones, umbilical cord harnia, apendix these surgeries are done by dr.suresh despande and dr. Radhika despande with the help of laproscopy.doctor behaviour with patient is like a family member.co staffs are nice. thank you so much for my surgeries.",
    id: 5,
    meta: "Hernia and Gallstones Care",
    icon: <FiUser className="carousel-icon" />,
  },
];

const maternityTestimonials = [
  {
    title: "Aruna Patil",
    description:
      "I have recieved a very caring treatment from Dr. Radhika Deshpande as regarding infertility. She has also delivered my first baby boy. I'm very much at ease in Swarup Hospital Gangavesh.They cover all Insurance companies.",
    id: 2,
    meta: "Infertility and Delivery Care",
    icon: <FiSmile className="carousel-icon" />,
  },
  {
    title: "Priya Kadam",
    description:
      "I am very much fortunate to get my pregnancy treatment at swaroop hospital. All the doctors specially Dr. Radhika and Dr. Mandar and their father are so caring and Frank in nature , they explained everything in detail.",
    id: 6,
    meta: "Maternity",
    icon: <FiHeart className="carousel-icon" />,
  },
  {
    title: "Manisha Kulkarni",
    description:
      "Grateful for the exceptional care and professionalism shown by the entire staff at Swaroop Hospital. From admission to discharge, every step felt reassuring.",
    id: 7,
    meta: "Maternity",
    icon: <FiStar className="carousel-icon" />,
  },
];

const surgeryTestimonials = [
  {
    title: "Aannasaheb Gaikwad",
    description:
      "We hhad good Orthopaedic surgery at the hands of Dr Mandar Deshpande in Swarup Hospital Gangavesh Dudhali,Our Patient has recovered quickly. We recommend Swarup Hospital next to Rankala St Stand to all .",
    id: 3,
    meta: "Orthopaedic Surgery",
    icon: <FiActivity className="carousel-icon" />,
  },
  {
    title: "Shivraj Patil",
    description:
      "Excellent orthopedic care with highly professional and friendly staff. The doctors explained everything clearly, and the entire team was supportive and attentive throughout my treatment. Highly recommended!",
    id: 8,
    meta: "Orthopaedic Surgery",
    icon: <FiUser className="carousel-icon" />,
  },
  {
    title: "Suhas Patil",
    description:
      "Dr.Suresh Deshpande,Dr Mandar Deshpande, & Dr Radhika have been a enormous support to the patient and our entire family .We have received good treatment for our 73 Yr old patient,She is fit and fine now.",
    id: 9,
    meta: "General Surgery",
    icon: <FiActivity className="carousel-icon" />,
  },
];

// eslint-disable-next-line no-unused-vars
const blogPosts = [
  {
    id: 1,
    title: "5 heart-health habits you can start today",
    category: "Heart Care",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    content: (
      <>
        <p>
          Your heart is the engine of your body. Keeping it healthy doesn't
          require a complete lifestyle overhaul. Small, consistent changes can
          make a big difference.
        </p>
        <h4>1. Move More</h4>
        <p>
          Aim for at least 30 minutes of moderate activity, like brisk walking,
          most days of the week. It lowers blood pressure and strengthens the
          heart muscle.
        </p>
        <h4>2. Eat Smart</h4>
        <p>
          Incorporate more fruits, vegetables, and whole grains. Reduce salt and
          sugar intake. Healthy fats like those found in nuts and olive oil are
          great for your heart.
        </p>
        <h4>3. Stress Less</h4>
        <p>
          Chronic stress can damage arteries. Practice deep breathing,
          meditation, or simply take time for hobbies you enjoy.
        </p>
        <h4>4. Sleep Well</h4>
        <p>
          Poor sleep is linked to higher risks of heart disease. Aim for 7-9
          hours of quality sleep each night.
        </p>
        <h4>5. Know Your Numbers</h4>
        <p>
          Regular checkups for blood pressure, cholesterol, and blood sugar are
          vital. Early detection is key to prevention.
        </p>
      </>
    ),
  },
  {
    id: 2,
    title: "Preparing for your child's vaccination visit",
    category: "Child Health",
    readTime: "3 min read",
    image:
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2808385.jpeg",
    content: (
      <>
        <p>
          Vaccinations are a crucial part of protecting your child's health. A
          little preparation can make the visit smoother and less stressful for
          both you and your little one.
        </p>
        <h4>Before the Visit</h4>
        <p>
          Bring your child's vaccination record. Pack a favorite toy or blanket
          for comfort. Dress them in loose-fitting clothes for easy access to
          the arm or leg.
        </p>
        <h4>During the Shot</h4>
        <p>
          Stay calm; your child picks up on your anxiety. Distract them with a
          story, song, or toy. Hold them securely but gently.
        </p>
        <h4>After Care</h4>
        <p>
          Some redness or mild fever is normal. Ask your doctor about using a
          cool compress or age-appropriate pain relief if needed. Extra cuddles
          always help!
        </p>
      </>
    ),
  },
  {
    id: 3,
    title: "When to visit the Emergency vs. Outpatient Clinic",
    category: "Emergency Care",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1516574187841-693083f69802?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    content: (
      <>
        <p>
          Knowing where to go can save time and ensuring you get the right level
          of care.
        </p>
        <h4>Go to Emergency (ER) for:</h4>
        <ul>
          <li>Chest pain or difficulty breathing</li>
          <li>Severe bleeding or deep wounds</li>
          <li>Sudden weakness, numbness, or slurred speech (Stroke signs)</li>
          <li>Severe abdominal pain</li>
          <li>Head injuries with loss of consciousness</li>
        </ul>
        <h4>Go to Outpatient / Clinic for:</h4>
        <ul>
          <li>Common cold, cough, or sore throat</li>
          <li>Minor cuts or burns</li>
          <li>Routine checkups and vaccinations</li>
          <li>Skin rashes or mild allergies</li>
          <li>Prescription refills</li>
        </ul>
        <p>
          If you are ever unsure and the situation feels life-threatening,
          always choose the ER or call 108 immediately.
        </p>
      </>
    ),
  },
];

const BlogModal = ({ post, onClose }) => {
  if (!post) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(11, 31, 58, 0.75)",
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        backdropFilter: "blur(8px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          maxWidth: "700px",
          width: "100%",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          border: "1px solid var(--color-border)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            zIndex: 10,
          }}
        >
          ×
        </button>

        <div style={{ height: "250px", overflow: "hidden", flexShrink: 0 }}>
          <img
            src={post.image}
            alt={post.title}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        <div style={{ padding: "30px", overflowY: "auto" }}>
          <span
            style={{
              background: "rgba(10, 132, 255, 0.08)",
              color: "var(--color-primary)",
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "700",
              display: "inline-block",
              marginBottom: "12px",
              textTransform: "uppercase",
            }}
          >
            {post.category}
          </span>

          <h2
            style={{
              fontSize: "1.8rem",
              color: "#0f172a",
              marginBottom: "10px",
              fontWeight: 800,
            }}
          >
            {post.title}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#64748b",
              marginBottom: "20px",
              fontWeight: 600,
            }}
          >
            {post.readTime}
          </p>

          <div
            style={{ lineHeight: "1.8", color: "#475569", fontSize: "1.05rem" }}
            className="modal-blog-content"
          >
            {post.content}
          </div>
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const navigate = useNavigate();

  const packages = [
    {
      title: "Full Body Check",
      badge: "FULL BODY CHECK-UP",
      description:
        "A complete health screening package designed to evaluate your overall health and detect medical conditions at an early stage.",
      features: [
        "Complete Blood & Urine Tests",
        "Heart & Vital Health Screening",
        "Doctor Consultation",
      ],
    },
    {
      title: "Orthopaedic Care",
      badge: "ORTHOPAEDIC CARE",
      description:
        "Specialized orthopaedic screening package for joint health, arthritis, spine problems and mobility assessment.",
      features: [
        "Bone & Joint Assessment",
        "Orthopaedic Consultation",
        "X-Ray & Diagnostic Evaluation",
      ],
    },
    {
      title: "Women Wellness",
      badge: "WOMEN WELLNESS",
      description:
        "Comprehensive women's preventive health package for reproductive, hormonal and overall wellness.",
      features: [
        "Gynaecology Consultation",
        "Women's Health Screening",
        "Preventive Diagnostic Tests",
      ],
    },
    {
      title: "Senior Citizen",
      badge: "SENIOR CARE",
      description:
        "A preventive health package specially designed for senior citizens to monitor overall health and support healthy ageing.",
      features: [
        "Complete Health Screening",
        "Diabetes & Heart Risk Assessment",
        "Specialist Doctor Consultation",
      ],
    },
  ];

  const [selectedPost, setSelectedPost] = useState(null);
  const [showEmergencyBanner, setShowEmergencyBanner] = useState(true);
  const [stats, setStats] = useState({
    param1Value: "NABH",
    param1Label: "Accredited Standards",
    yearsOfService: "15+",
    happyPatients: "50k+",
    param4Value: "24/7",
    param4Label: "Emergency Support",
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const docRef = doc(db, "settings", "aboutStats");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setStats({
            param1Value: data.param1Value || "NABH",
            param1Label: data.param1Label || "Accredited Standards",
            yearsOfService: data.yearsOfService
              ? data.yearsOfService + "+"
              : "15+",
            happyPatients: data.happyPatients
              ? data.happyPatients + "k+"
              : "50k+",
            param4Value: data.param4Value || "24/7",
            param4Label: data.param4Label || "Emergency Support",
          });
        }
      } catch (err) {
        console.error("Error fetching about stats: ", err);
      }
    };
    fetchStats();
  }, []);

  const handleLearnMore = () => {
    navigate("/contact#contact-form");
  };

  useEffect(() => {
    // Stagger slide entry for checkup packages
    gsap.fromTo(
      ".package-card",
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".packages-grid",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      },
    );
  }, []);

  return (
    <>
      <HeroBanner />

      {/* TRUST INDICATORS STRIP */}
      <div className="trust-strip-wrapper">
        <div className="trust-strip-container">
          <div className="trust-item">
            <FiAward className="trust-icon" />
            <div className="trust-text">
              <h4>{stats.param1Value}</h4>
              <p>{stats.param1Label}</p>
            </div>
          </div>
          <div className="trust-item-divider" />
          <div className="trust-item">
            <FiUser className="trust-icon" />
            <div className="trust-text">
              <h4>
                <CountUp
                  end={parseInt(stats.yearsOfService, 10) || 0}
                  suffix="+"
                  duration={2}
                  enableScrollSpy
                  scrollSpyOnce
                />
              </h4>
              <p>Years of Service</p>
            </div>
          </div>
          <div className="trust-item-divider" />
          <div className="trust-item">
            <FiShield className="trust-icon" />
            <div className="trust-text">
              <h4>
                <CountUp
                  end={parseInt(stats.happyPatients, 10) || 0}
                  suffix="k+"
                  duration={2.5}
                  enableScrollSpy
                  scrollSpyOnce
                />
              </h4>
              <p>Happy Patients</p>
            </div>
          </div>
          <div className="trust-item-divider" />
          <div className="trust-item">
            <FiHeart className="trust-icon" />
            <div className="trust-text">
              <h4>{stats.param4Value}</h4>
              <p>{stats.param4Label}</p>
            </div>
          </div>
        </div>
      </div>

      {/* ProHealth Section - Premium Redesigned Packages */}
      <section
        className="section section-packages"
        style={{ background: "#ffffff", width: "100%", padding: "100px 5%" }}
      >
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div className="section-header">
            <span className="section-tag">Wellness Packages</span>
            <h2 className="section-title">Swarup ProHealth Packages</h2>
            <p className="section-subtitle">
              Stay one step ahead with preventive healthcare at Swarup Hospital, Kolhapur. Our health check-up packages are designed for every stage of life, helping you detect health concerns early and maintain long-term wellness for you and your family.
            </p>
          </div>

          <div className="packages-grid">
            {packages.map((pkg) => (
              <div key={pkg.title} className="package-card">
                <div className="card-badge">{pkg.badge}</div>

                <h3 className="package-name">{pkg.title}</h3>

                <p className="package-desc">
                  {pkg.description}
                </p>

                <div className="package-features">
                  {pkg.features.map((feature, index) => (
                    <div className="feat-item" key={index}>
                      <FiCheckCircle className="feat-check" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <button
                  className="btn-package"
                  onClick={() => handleLearnMore(pkg.title)}
                >
                  Learn More
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Departments />

      {/* NEW: ADVANCED MEDICAL TECHNOLOGY SECTION */}
      <section
        className="section tech-section"
        style={{ background: "#ffffff" }}
      >
        <div className="section-header">
          <span className="section-tag">Infrastructure</span>
          <h2 className="section-title">Advanced Medical Technology</h2>
          <p className="section-subtitle">
            Our modern operation theatres, diagnostic facilities and advanced medical equipment support accurate diagnosis, safe procedures and quality patient care in a comfortable hospital environment.
          </p>
        </div>
        <div className="tech-grid">
          <div className="tech-card">
            <FiCpu className="tech-icon" />
            <h4>Personalized Patient Care</h4>
            <p>
              Every treatment plan is tailored to the patient's condition, ensuring compassionate care, clear communication and better recovery outcomes.
            </p>
          </div>
          <div className="tech-card">
            <FiActivity className="tech-icon" />
            <h4>Multi-Speciality Expertise</h4>
            <p>
             Comprehensive medical and surgical care delivered by experienced specialists across orthopaedics, general surgery, gynaecology and anaesthesia.
            </p>
          </div>
          <div className="tech-card">
            <FiShield className="tech-icon" />
            <h4>Cashless Insurance Support</h4>
            <p>
             Hassle-free cashless hospitalization with leading insurance providers and TPA assistance for a smoother patient experience.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section
        id="testimonials"
        className="section"
        style={{ background: "#ffffff", width: "100%", padding: "100px 5%" }}
      >
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div className="section-header">
            <span className="section-tag">Testimonials</span>
            <h2 className="section-title">Patient Stories</h2>
            <p className="section-subtitle">
              Real patient experiences that reflect compassionate care, trusted medical support and dedicated healthcare services at Swarup Hospital, Kolhapur.
            </p>
          </div>

          <div
            className="testimonials-grids-wrapper"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "30px",
            }}
          >
            {/* General Care Carousel */}
            <div
              style={{ flex: "1 1 300px", maxWidth: "400px" }}
              className="testimonials-col"
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "20px",
                  color: "#0f172a",
                  fontSize: "1.2rem",
                  fontWeight: 800,
                }}
              >
                General Care
              </h3>
              <div
                style={{
                  minHeight: "520px",
                  height: "auto",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "stretch",
                }}
              >
                <Carousel
                  items={generalTestimonials}
                  baseWidth={330}
                  autoplay={true}
                  autoplayDelay={4000}
                  pauseOnHover={true}
                  loop={true}
                  round={false}
                />
              </div>
            </div>

            {/* Maternity Carousel */}
            <div
              style={{ flex: "1 1 300px", maxWidth: "400px" }}
              className="testimonials-col"
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "20px",
                  color: "#0f172a",
                  fontSize: "1.2rem",
                  fontWeight: 800,
                }}
              >
                Maternity & Child
              </h3>
              <div
                style={{
                  minHeight: "520px",
                  height: "auto",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "stretch",
                }}
              >
                <Carousel
                  items={maternityTestimonials}
                  baseWidth={330}
                  autoplay={true}
                  autoplayDelay={5000}
                  pauseOnHover={true}
                  loop={true}
                  round={false}
                />
              </div>
            </div>

            {/* Surgery Carousel */}
            <div
              style={{ flex: "1 1 300px", maxWidth: "400px" }}
              className="testimonials-col"
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "20px",
                  color: "#0f172a",
                  fontSize: "1.2rem",
                  fontWeight: 800,
                }}
              >
                Surgery & Rehab
              </h3>
              <div
                style={{
                  minHeight: "520px",
                  height: "auto",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "stretch",
                }}
              >
                <Carousel
                  items={surgeryTestimonials}
                  baseWidth={330}
                  autoplay={true}
                  autoplayDelay={6000}
                  pauseOnHover={true}
                  loop={true}
                  round={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INSURANCE SECTION */}
      <section
        className="section insurance-section"
        style={{
          background: "#ffffff",
          padding: "100px 0",
          textAlign: "center",
        }}
      >
        <div className="section-header">
          <span className="section-tag">Cashless Mediclaim</span>
          <h2 className="section-title">
            Partnered with 30+ Insurance Companies
          </h2>
          <p className="section-subtitle">
            Swarup Hospital is associated with leading health insurance
            companies and Third-Party Administrators (TPAs) to provide seamless
            cashless hospitalization services. Our dedicated insurance
            assistance team guides patients through pre-authorization,
            documentation, claim processing, and discharge formalities, making
            the entire treatment journey smooth and stress-free.
          </p>
        </div>

        <div
          style={{
            maxWidth: "100%",
            margin: "40px auto 0",
            overflow: "hidden",
            position: "relative",
            background: "#ffffff",
            padding: "30px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              animation: "scroll 30s linear infinite",
              width: "max-content",
            }}
          >
            {[
              { num: 1, ext: "png" },
              { num: 2, ext: "png" },
              { num: 3, ext: "png" },
              { num: 4, ext: "png" },
              { num: 5, ext: "png" },
              { num: 6, ext: "png" },
              { num: 7, ext: "png" },
              { num: 8, ext: "png" },
              { num: 9, ext: "png" },
              { num: 10, ext: "png" },
              { num: 11, ext: "png" },
              { num: 12, ext: "png" },
              { num: 13, ext: "jpg" },
              { num: 14, ext: "png" },
              { num: 15, ext: "png" },
              { num: 16, ext: "png" },
              { num: 17, ext: "png" },
              { num: 18, ext: "png" },
              { num: 19, ext: "jpg" },
              { num: 20, ext: "jpg" },
              { num: 21, ext: "png" },
              { num: 22, ext: "jpg" },
              { num: 23, ext: "jpg" },
              { num: 24, ext: "webp" },
              { num: 25, ext: "png" },
              { num: 26, ext: "png" },
            ].map(({ num, ext }) => (
              <img
                key={num}
                src={`/assets/images/${num}.${ext}`}
                alt={`Insurance ${num}`}
                style={{
                  height: "70px",
                  objectFit: "contain",
                  margin: "0 40px",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
            {[
              { num: 1, ext: "png" },
              { num: 2, ext: "png" },
              { num: 3, ext: "png" },
              { num: 4, ext: "png" },
              { num: 5, ext: "png" },
              { num: 6, ext: "png" },
              { num: 7, ext: "png" },
              { num: 8, ext: "png" },
              { num: 9, ext: "png" },
              { num: 10, ext: "png" },
              { num: 11, ext: "png" },
              { num: 12, ext: "png" },
              { num: 13, ext: "jpg" },
              { num: 14, ext: "png" },
              { num: 15, ext: "png" },
              { num: 16, ext: "png" },
              { num: 17, ext: "png" },
              { num: 18, ext: "png" },
              { num: 19, ext: "jpg" },
              { num: 20, ext: "jpg" },
              { num: 21, ext: "png" },
              { num: 22, ext: "jpg" },
              { num: 23, ext: "jpg" },
              { num: 24, ext: "webp" },
              { num: 25, ext: "png" },
              { num: 26, ext: "png" },
            ].map(({ num, ext }) => (
              <img
                key={`dup-${num}`}
                src={`/assets/images/${num}.${ext}`}
                alt={`Insurance ${num}`}
                style={{
                  height: "70px",
                  objectFit: "contain",
                  margin: "0 40px",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </div>
          <style>{`
            @keyframes scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}</style>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <div
            style={{
              padding: "10px 20px",
              borderRadius: "30px",
              background: "var(--color-primary)",
              color: "white",
              fontWeight: 600,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
            onClick={() => navigate("/insurance")}
          >
            View All Partners{" "}
            <FiChevronDown style={{ transform: "rotate(-90deg)" }} />
          </div>
        </div>
      </section>

      {/* Blog Modal */}
      <BlogModal post={selectedPost} onClose={() => setSelectedPost(null)} />

      <Contact />
    </>
  );
};

export default Home;
